import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useEffect, useState } from "react";
import wp from "wp";
/**
 * @param chunkFile Use `__webpack_get_script_filename__`
 */

function useChunkTranslation(chunkFile, _ref) {
  var chunks = _ref.chunks,
      publicUrl = _ref.publicUrl,
      textDomain = _ref.textDomain,
      version = _ref.version;
  var suffixes = chunks[chunkFile.split("?")[0]]; // We need to remove the query argument from `output.chunkFilename`

  var exists = !!suffixes;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      done = _useState2[0],
      setDone = _useState2[1];

  var fetchTranslationBySuffix = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(suffix) {
      var w, chunkUrls, urlToJson, response, _yield$response$json, messages;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Do never load twice
              w = window;
              w.wpi18nLazy = w.wpi18nLazy || {};
              w.wpi18nLazy.chunkUrls = w.wpi18nLazy.chunkUrls || [];
              chunkUrls = w.wpi18nLazy.chunkUrls;
              urlToJson = "".concat(publicUrl, "languages/json/").concat(textDomain, "-").concat(suffix, ".json");

              if (!(exists && chunkUrls.indexOf(urlToJson) === -1)) {
                _context.next = 20;
                break;
              }

              chunkUrls.push(urlToJson);
              _context.prev = 7;
              _context.next = 10;
              return window.fetch("".concat(urlToJson, "?ver=").concat(version));

            case 10:
              response = _context.sent;
              _context.next = 13;
              return response.json();

            case 13:
              _yield$response$json = _context.sent;
              messages = _yield$response$json.locale_data.messages;
              wp.i18n.setLocaleData(messages, textDomain);
              _context.next = 20;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](7);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 18]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [publicUrl, textDomain]);
  useEffect(function () {
    if (exists) {
      Promise.all(suffixes.map(fetchTranslationBySuffix)).then(function () {
        setDone(true);
      });
    } else {
      setDone(true);
    }
  }, [exists, fetchTranslationBySuffix]);
  return done;
}

export { useChunkTranslation };